import { render, staticRenderFns } from "./commentTask.vue?vue&type=template&id=664932d1&scoped=true&"
import script from "./commentTask.vue?vue&type=script&lang=js&"
export * from "./commentTask.vue?vue&type=script&lang=js&"
import style0 from "./commentTask.vue?vue&type=style&index=0&id=664932d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664932d1",
  null
  
)

export default component.exports